import { render } from "./mainMenu.vue?vue&type=template&id=10cd4a20&scoped=true"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"

import "./mainMenu.vue?vue&type=style&index=0&id=10cd4a20&scoped=true&lang=css"

import exportComponent from "/Users/michael/Desktop/Development/vue/godservice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cd4a20"]])

export default __exports__